/* Moonou Launch-Aktion — clientseitige Start-/Ablauf-Logik.
 *
 * Liquid-`now` ist wegen Page-Caching unzuverlässig, deshalb entscheidet
 * dieses Skript clientseitig, ob die Aktions-Elemente ([data-launch-promo])
 * sichtbar sind: sichtbar nur wenn gestartet UND nicht abgelaufen.
 *
 * Zeit-Quellen pro Element (in dieser Prio):
 *   1. data-launch-promo-deadline-ts / data-launch-promo-start-ts —
 *      Unix-Timestamps (Sekunden), serverseitig via Liquid `| date: '%s'` in
 *      der Store-Zeitzone (Europe/Berlin) erzeugt. Zeitzonen-sicher,
 *      unabhängig von der Browser-Lokalzeit des Kunden.
 *   2. data-launch-promo-deadline / data-launch-promo-start — ISO-Strings,
 *      Fallback (Browser-Lokalzeit!).
 * Fehlende/leere Start-Attribute = sofort aktiv, fehlendes Ende = kein Ablauf.
 *
 * Elemente mit gesetztem Startdatum werden serverseitig mit der Klasse
 * moonou-launch-promo--pending (display:none) gerendert — der Sweep blendet
 * sie EIN, sobald der Start erreicht ist (und wieder AUS nach der Deadline).
 * Beide Richtungen laufen auch im 30s-Intervall, damit Start/Ende bei lange
 * offenem Tab pünktlich greifen.
 *
 * x-modal-Elemente (Gift-Picker) werden nur geschlossen, nie eingeblendet —
 * sie sind ohnehin bis show() unsichtbar; das Gating macht der ATC-Intercept
 * (moonou-gift-picker.js) über isActive().
 *
 * Wird von mehreren Komponenten eingebunden (PDP-Banner, ATC-Zeile,
 * Collection-Hero, Gift-Picker) — der Guard macht Mehrfach-Einbindung harmlos.
 */
(function () {
  if (window.MoonouLaunchPromo) return;

  function parseTime(iso, ts) {
    var time = NaN;
    if (ts) time = parseInt(ts, 10) * 1000;
    if (isNaN(time) && iso) time = new Date(iso).getTime();
    return time;
  }

  var api = (window.MoonouLaunchPromo = {
    /* deadline: ISO-String (Fallback), deadlineTs: Unix-Sekunden (bevorzugt) */
    isExpired: function (deadline, deadlineTs) {
      var time = parseTime(deadline, deadlineTs);
      return !isNaN(time) && time <= Date.now();
    },

    /* Kein/leeres Startdatum = gestartet (sofort aktiv, kein Breaking Change) */
    isStarted: function (start, startTs) {
      var time = parseTime(start, startTs);
      return isNaN(time) || time <= Date.now();
    },

    isElementExpired: function (el) {
      return api.isExpired(
        el.getAttribute('data-launch-promo-deadline'),
        el.getAttribute('data-launch-promo-deadline-ts')
      );
    },

    isElementStarted: function (el) {
      return api.isStarted(
        el.getAttribute('data-launch-promo-start'),
        el.getAttribute('data-launch-promo-start-ts')
      );
    },

    /* Aktion für dieses Element gerade aktiv? (gestartet && nicht abgelaufen) */
    isElementActive: function (el) {
      return api.isElementStarted(el) && !api.isElementExpired(el);
    }
  });

  function sweep() {
    document.querySelectorAll('[data-launch-promo]').forEach(function (el) {
      var active = api.isElementActive(el);

      if (typeof el.hide === 'function') {
        /* x-modal (Gift-Picker): sauber schließen statt hart ausblenden;
           einblenden macht ausschließlich der ATC-Intercept. */
        if (!active) el.hide();
        return;
      }

      if (active) {
        el.classList.remove('moonou-launch-promo--pending');
        el.hidden = false;
        el.style.removeProperty('display');
      } else {
        el.hidden = true;
        el.style.setProperty('display', 'none', 'important');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweep);
  } else {
    sweep();
  }

  /* Re-Check in BEIDE Richtungen: Aktion erscheint pünktlich zum Start und
     verschwindet pünktlich zur Deadline, auch bei lange offenem Tab. */
  setInterval(sweep, 30000);
})();
